module.exports = __webpack_public_path__ + "img/logo.472c4a63.svg";